import { useMemo } from "react";
import { useMatch } from "react-router";
import {
  ROUTE_BROWSE_JOBS_INTERACTIVE,
  ROUTE_BROWSE_JOBS_LIST,
  ROUTE_BROWSE_LOGS_INTERACTIVE,
  ROUTE_BROWSE_LOGS_LIST,
  ROUTE_BROWSE_RELAYS_LIST,
  ROUTE_BROWSE_RELAYS_INTERACTIVE,
  ROUTE_BROWSE_SENSORS_LIST,
  ROUTE_BROWSE_SENSORS_INTERACTIVE,
  ROUTE_BROWSE_SESSIONS_INTERACTIVE,
  ROUTE_BROWSE_SESSIONS_LIST,
  ROUTE_BROWSE_WAYPOINTS_INTERACTIVE,
  ROUTE_BROWSE_WAYPOINTS_LIST
} from "@/constants/Route.constant";

export const useBrowseMatch = () => {
  // Interactive routes
  const isJobsInteractive = useMatch({
    path: ROUTE_BROWSE_JOBS_INTERACTIVE,
    end: true
  });
  const isRelaysInteractive = useMatch({
    path: ROUTE_BROWSE_RELAYS_INTERACTIVE,
    end: true
  });
  const isSensorsInteractive = useMatch({
    path: ROUTE_BROWSE_SENSORS_INTERACTIVE,
    end: true
  });
  const isSessionsInteractive = useMatch({
    path: ROUTE_BROWSE_SESSIONS_INTERACTIVE,
    end: true
  });
  const isLogsInteractive = useMatch({
    path: ROUTE_BROWSE_LOGS_INTERACTIVE,
    end: true
  });
  const isWaypointsInteractive = useMatch({
    path: ROUTE_BROWSE_WAYPOINTS_INTERACTIVE,
    end: true
  });

  // List routes
  const isJobsList = useMatch({
    path: ROUTE_BROWSE_JOBS_LIST,
    end: true
  });
  const isRelaysList = useMatch({
    path: ROUTE_BROWSE_RELAYS_LIST,
    end: true
  });
  const isSensorsList = useMatch({
    path: ROUTE_BROWSE_SENSORS_LIST,
    end: true
  });
  const isSessionsList = useMatch({
    path: ROUTE_BROWSE_SESSIONS_LIST,
    end: true
  });
  const isWaypointsList = useMatch({
    path: ROUTE_BROWSE_WAYPOINTS_LIST,
    end: true
  });
  const isLogsList = useMatch({
    path: ROUTE_BROWSE_LOGS_LIST,
    end: true
  });

  return useMemo(
    () => ({
      isJobs: !!isJobsInteractive || !!isJobsList,
      isLogs: !!isLogsInteractive || !!isLogsList,
      isRelays: !!isRelaysInteractive || !!isRelaysList,
      isSensors: !!isSensorsInteractive || !!isSensorsList,
      isSessions: !!isSessionsInteractive || !!isSessionsList,
      isWaypoints: !!isWaypointsInteractive || !!isWaypointsList,
      isInteractive:
        !!isJobsInteractive ||
        !!isLogsInteractive ||
        !!isSensorsInteractive ||
        !!isSessionsInteractive ||
        !!isRelaysInteractive ||
        !!isWaypointsInteractive,
      isList:
        !!isJobsList ||
        !!isLogsList ||
        !!isRelaysList ||
        !!isSensorsList ||
        !!isSessionsList ||
        !!isWaypointsList
    }),
    [
      isJobsInteractive,
      isJobsList,
      isLogsInteractive,
      isLogsList,
      isRelaysInteractive,
      isRelaysList,
      isSensorsInteractive,
      isSensorsList,
      isSessionsInteractive,
      isSessionsList,
      isWaypointsInteractive,
      isWaypointsList
    ]
  );
};
